import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import vuetify from './plugins/vuetify'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import Validtor from './components/mixin/validator'
import Redirect from './components/mixin/redirect'
import Config from './components/mixin/config'
import VueCookies from 'vue-cookies'

import '@/assets/scss/common.scss'

Vue.use(VueCookies);
Vue.use(Viewer);

Vue.mixin(Validtor);
Vue.mixin(Redirect);
Vue.mixin(Config);

Vue.config.productionTip = false

window.vue = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')

window.vue.$vuetify.rtl = window.vue.$i18n.locale === 'ar';